<template>
    <div class="storm-box">
        <div class="title-bar">
            <led-timer v-if="timerRequired" :time-in-seconds="timeInSeconds" type="countdown" />
            <div class="title" :class="{'no-timer': ! timerRequired}">{{ activity.title }}</div>
            <div v-visible="memberCount > 0" class="stat-info">
                <span v-show="!allSubmitted" class="label">已提交</span>
                <span v-show="!allSubmitted" class="data">{{ activity.results.length }}</span>
                <span v-show="!allSubmitted" class="label">未提交</span>
                <span v-show="!allSubmitted" class="data">{{ memberCount - activity.results.length }}</span>
                <span v-show="allSubmitted" class="label">全部已提交</span>
            </div>
        </div>

        <!-- no one answered the question -->
        <div v-if="!hasResults" ref="emptyResultHintBox" class="empty-result-hint"> 
            <div class="hint-content">
                {{ hintContent }}
            </div>
        </div>

        <div ref="positions" class="positions">
            <div v-show="showSubject" ref="subjectBox" class="subject-box">
                <div class="text-content">
                    <span v-html="'主题: ' + activity.content"></span> 
                    <img v-if="activity.image" src="../assets/image/stotm_detail_icon.png">
                </div>
            </div>

            <div v-show="hasResults" ref="tagsBox" class="tag-box clearfix">
                <div :class="{'selected': selectedTagId == -1}" class="tag">全部 ({{ activity.results.length }})</div>
                <div v-for="tag in activity.tags" :key="tag.id" :class="{'selected': selectedTagId == tag.id}" class="tag">{{ tag.tag }} ({{ tag.resultCount }})</div>
            </div>

            <div ref="resultsBox" :style="resultsBoxStyleString" class="result-box">
                <div class="left-col">
                    <div v-for="result in leftResults" 
                         :id="'result-box-' + result.id"
                         :key="result.id" 
                         :style="result.bgStyleString" class="result-block">
                        <div class="result-header">
                            <div class="avatar">
                                <img :src="result.user.avatarUrl ? result.user.avatarUrl : userAvatarUrl">
                            </div>
                            <div class="info">
                                <div class="name">{{ result.user.fullName }}</div>
                                <div class="student-no">{{ result.user.studentNo }}</div>
                            </div>
                        </div>
                        <div class="result-body">
                            <div class="text-content" v-html="result.content"></div>
                            <div v-if="result.attachments && result.attachments.length > 0" :style="result.imageBoxStyleString" class="image-box">
                                <img :src="result.attachments[0].url" alt="" :style="result.imageStyleString">
                            </div>
                        </div>
                        <div class="result-footer">
                            <div class="time-info">{{ result.submitTime }}</div>
                            <div class="like-info">
                                <div v-if="result.likeScore > 0" class="like-score">+{{ result.likeScore }} 经验值</div>
                                <div :class="{'has-like': result.likeCount > 0}" class="like-button"></div>
                                <div v-if="result.likeCount > 0" class="like-count">{{ result.likeCount }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-col">
                    <div v-for="result in rightResults" 
                         :id="'result-box-' + result.id" 
                         :key="result.id" 
                         :style="result.bgStyleString" 
                         class="result-block">
                        <div class="result-header">
                            <div class="avatar">
                                <img :src="result.user.avatarUrl ? result.user.avatarUrl : userAvatarUrl">
                            </div>
                            <div class="info">
                                <div class="name">{{ result.user.fullName }}</div>
                                <div class="student-no">{{ result.user.studentNo }}</div>
                            </div>
                        </div>
                        <div class="result-body">
                            <div class="text-content" v-html="result.content"></div>
                            <div v-if="result.attachments && result.attachments.length > 0" :style="result.imageBoxStyleString" class="image-box">
                                <img :src="result.attachments[0].url" alt="" :style="result.imageStyleString">
                            </div>
                        </div>
                        <div class="result-footer">
                            <div class="time-info">{{ result.submitTime }}</div>
                            <div class="like-info">
                                <div v-if="result.likeScore > 0" class="like-score">+{{ result.likeScore }} 经验值</div>
                                <div :class="{'has-like': result.likeCount > 0}" class="like-button"></div>
                                <div v-if="result.likeCount > 0" class="like-count">{{ result.likeCount }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="selectedImage != null" class="expand-image-box">
                <img ref="selectedImage" :src="selectedImage.src" alt="" :style="selectedImage.styleString" :class="selectedImage.src == loading ? 'imgAnimation' : ''">
            </div>
        </div>


        <!-- THIS IS THE TEST COLUMN FOR DETECTING BLOCK HEIGHT -->
        <div class="result-box" style="visibility: hidden;">
            <div ref="testHeightCol" class="left-col">
                <div v-for="result in tempResults" :key="result.id" :style="result.bgStyleString" class="result-block">
                    <div class="result-header">
                        <div class="avatar">
                            <!-- <img src="/images/storm-test/40_80.png"> -->
                        </div>
                        <div class="info">
                            <div class="name">{{ result.user.fullName }}</div>
                            <div class="student-no">{{ result.user.studentNo }}</div>
                        </div>
                    </div>
                    <div class="result-body">
                        <div class="text-content" v-html="result.content"></div>
                        <div v-if="result.attachments && result.attachments.length > 0" :style="result.imageBoxStyleString" class="image-box">
                            <img :src="result.attachments[0].url" alt="" :style="result.imageStyleString">
                        </div>
                    </div>
                    <div class="result-footer">
                        <div class="time-info">{{ result.submitTime }}</div>
                        <div class="like-info">
                            <div v-if="result.likeScore > 0" class="like-score">+{{ result.likeScore }} 经验值</div>
                            <div :class="{'has-like': result.likeCount > 0}" class="like-button"></div>
                            <div v-if="result.likeCount > 0" class="like-count">{{ result.likeCount }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="selectedResult != null" 
             :class="{'has-tags': selectedResult != null && selectedResult.tags && selectedResult.tags.length > 0}" 
             class="expand-result-container">
            <div v-if="selectedResult != null && selectedResult.tags && selectedResult.tags.length > 0" class="tag-box clearfix">
                <div v-for="tag in selectedResult.tags" :key="'expand-' + tag.id" class="tag">{{ tag.tag }}</div>
            </div>
            <div ref="expandResultBox" class="expand-result-box">
                <div class="result-block">
                    <div class="result-header">
                        <div class="left">
                            <div class="avatar">
                                <!-- <img :src="selectedResult.user.avatarUrl" alt=""> -->
                                <img :src="selectedResult.user.avatarUrl ? selectedResult.user.avatarUrl : userAvatarUrl">
                            </div>
                            <div class="info">
                                <div class="name">{{ selectedResult.user.fullName }}</div>
                                <div class="student-no">{{ selectedResult.user.studentNo }}</div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="like-info">
                                <div v-if="selectedResult.likeScore > 0" class="like-score">+{{ selectedResult.likeScore }} 经验值</div>
                                <div :class="{'has-like': selectedResult.likeCount > 0}" class="like-button"></div>
                                <div v-if="selectedResult.likeCount > 0" class="like-count">{{ selectedResult.likeCount }}</div>
                            </div>
                            <div class="time-info">{{ selectedResult.submitTime }}</div>
                        </div>
                    </div>
                    <div class="result-body">
                        <div class="text-content" v-html="selectedResult.content"></div>
                        <div v-if="selectedResult.attachments && selectedResult.attachments.length > 0" 
                             :style="selectedResult.imageBoxStyleString" 
                             class="image-box">
                            <img :src="selectedResult.attachments[0].url" alt="" :style="selectedResult.imageStyleString">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userAvatarUrl from '../assets/image/user-avatarUrl.jpg';
import detailIcon from '../assets/image/stotm_detail_icon.png';
import loading from '@/assets/image/loading.png';
import ledTimer from './ledTimer.vue';
import moment from 'moment';
import Wings from '../assets/scripts/wings.js';
import tool from '@/assets/scripts/tool.js';
import Vue from 'vue';

export default {
    components: {
        ledTimer
    },

    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        },
        userId: {
            type: String,
            default: ''
        }
    },
    

    data: function() {
        return {
            detailIcon: detailIcon,
            loading: loading,
            bgColors: [
                '#D18400',
                '#4A7FB5',
                '#3C896D',
                '#C56073',
                '#AA8748',
                '#6E748C'
            ],
            componentId: null,
            memberCount: 0,
            activity: {
                results: [],
                tags: []
            },
            emptyResultHintBoxStyleString: '',
            resultsBoxStyleString: '',
            showSubject: false,
            shownResults: [], // the shown results, for tag switching
            tempResults: [], // this is results for testing result block height
            leftResults: [], // the results should placed in left column
            leftHeight: 0,   // the total height of left column
            rightResults: [], // the results should placed in right column
            rightHeight: 0,   // the total height of right column
            selectedTagId: -1,
            selectedResult: null,
            supportedEventNames: [
                'activity.storm.show',
                'common.waiting',
                'common.fontsize',
                'activity.storm.newResult',
                'activity.storm.like',
                'activity.storm.cancelLike',
                'common.fontsize',
                'activity.storm.showDetail',
                'activity.storm.hideDetail',
                'activity.storm.showDetailImage',
                'activity.storm.hideDetailImage', 
                'activity.storm.showResult',
                'activity.storm.hideResult',
                'activity.storm.showResultImage',
                'activity.storm.hideResultImage',
                'activity.storm.selectTag',
                'activity.storm.addTag',
                'activity.storm.removeTag',
                'activity.storm.intelliTag',
                'files.zoom',
                'files.rotate',
                'common.moveJoystick'
            ],
            wings1: null,
            wings4: null,
            wings7: null,
            wingsAll: null,
            userAvatarUrl: userAvatarUrl,
            selectedImage: null,
            selectedImageScale: null,
            moveX: 0,
            moveY: 0,
            rotate: 0,
        };
    },

    computed: {
        hintContent: function() {
            return this.activity.status === 'END' ? '很遗憾，没有学生作答' : '快来发表你的想法吧～';
        },
        allSubmitted: function() {
            return (this.memberCount <= this.activity.results.length);
        },

        hasResults: function() {
            return this.activity ? this.activity.results.length > 0 : false;
        },

        timeInSeconds: function() {
            if ( ! this.timerRequired) return 0;
            let d = new Date(this.activity.autoEndTime);
            d = Math.floor(d.getTime() / 1000);
            return (d - this.serverTimestamp);
        },

        /**
         * 用来判断是否需要现实计时器的
         */
        timerRequired: function() {
            return this.activity.status === 'IN_PRGRS' && this.activity.autoEnd === 'Y';
        }
    },

    watch:{
        currentShow (newVal, oldVal) {
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.resetScene();
            }
        },

        showSubject: function(newVal, oldVal) {
            // showing
            if (newVal && ! oldVal) {
                Vue.nextTick(() => {
                    const rect = this.$refs.subjectBox.getBoundingClientRect();
                    const tagsBoxRect = this.$refs.tagsBox ? this.$refs.tagsBox.getBoundingClientRect() : {width: 0, height: 0};
                    this.emptyResultHintBoxStyleString = 'top: ' + (80 + rect.height + tagsBoxRect.height) + 'px';
                    this.resultsBoxStyleString = 'top: ' + (80 + rect.height + tagsBoxRect.height) + 'px';
                });
                return;
            }

            // hiding
            if ( ! newVal && oldVal) {
                this.emptyResultHintBoxStyleString = '';
                this.resultsBoxStyleString = '';
            }
        },
    },


    created: function() {
        this.wingsAll = new Wings();
    },

    mounted: function() {
        this.componentId = this.$attrs.id;

        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },

    
    methods: {
        windowMessageHandler: function(e) {
            let msg = e.data;
            if (!msg.eventName) return;
            if (this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            // console.log(e.data);
            let msgData = msg.data;

            // Lock status, do not respond to any message
            if (this.isLock && this.currentShow === this.componentId) return;
            if (!this.isLock && this.currentShow !== this.componentId) return;

            switch (msg.eventName) {
                case 'activity.storm.show':
                    // if (msgData.activity.id === this.activity.id) return;
                    this.handleShowMessage(msgData);
                    break;
                case 'activity.storm.newResult':
                    if (msgData.activityId !== this.activity.id) return;
                    this.handleNewResultMessage(msgData);
                    break;
                case 'activity.storm.showResult':
                    if (msgData.id !== this.activity.id) return;
                    this.expandResult(msgData.resultId);
                    break;
                case 'activity.storm.hideResult':
                    if (msgData.id !== this.activity.id) return;
                    this.collapseResult(msgData.resultId);
                    break;
                case 'activity.storm.showResultImage':
                    // console.log(msgData.entityId,this.activity.id); 
                    if (msgData.entityId !== this.activity.id) return;
                    this.handleShowImageMessage(msgData.subEntityId);
                    break;
                case 'activity.storm.hideResultImage':
                    if (msgData.entityId !== this.activity.id) return;
                    this.handleHideImageMessage(msgData.subEntityId);
                    break;
                case 'activity.storm.like':
                    if (msgData.activityId !== this.activity.id) return;
                    this.handleLikeMessage(msgData);
                    break;
                case 'activity.storm.cancelLike':
                    if (msgData.activityId !== this.activity.id) return;
                    this.handleCancelLikeMessage(msgData);
                    break;
                case 'activity.storm.selectTag':
                    if (msgData.id !== this.activity.id) return;
                    this.handleSelectTagMessage(msgData);
                    break;
                case 'activity.storm.addTag':
                    if (msgData.id !== this.activity.id) return;
                    this.handleAddTagMessage(msgData);
                    break;
                case 'activity.storm.removeTag':
                    if (msgData.id !== this.activity.id) return;
                    this.handleRemoveTagMessage(msgData);
                    break;
                case 'activity.storm.intelliTag':
                    if (msgData.activity.id !== this.activity.id) return;
                    this.handleShowMessage(msgData);
                    break;
                case 'activity.storm.showDetail':
                    if (msgData.id !== this.activity.id) return;
                    this.showSubject = true;
                    break;
                case 'activity.storm.hideDetail':
                    if (msgData.id !== this.activity.id) return;
                    this.showSubject = false;
                    break;
                case 'activity.storm.showDetailImage':
                    if (this.activity.image && this.activity.image.url) {
                        this.showImage({
                            relationId: this.activity.image.relationId,
                            src: this.activity.image.url
                        });
                    }
                    break;
                case 'activity.storm.hideDetailImage':
                    this.selectedImage = null;
                    this.selectedImageScale = null;
                    this.$refs.selectedImage.style.transform = '';
                    this.moveX = 0;
                    this.moveY = 0;
                    this.rotate = 0;
                    break;
                case 'files.zoom':
                    console.log(msgData)
                    this.zoomTo(msgData);
                    break;
                case 'files.rotate':
                    this.rotateImg(msgData);
                    break;
                case 'common.moveJoystick':
                    this.moveJoystick(msgData);
                    break;

                    
                default:
                    console.log('I don\'t understand this event ', msg.eventName);
            }
        },

        resetScene: function() {
            this.memberCount = 0;
            this.activity = {
                results: [],
                tags: []
            };
            this.selectedTagId = -1;
            this.leftHeight = 0;
            this.rightHeight = 0;
            this.leftResults.splice(0);
            this.rightResults.splice(0);
            this.shownResults = [];
            this.showSubject = false;
            this.selectedImage = null;
            this.selectedResult = null;
            this.$refs.positions.scrollTop = 0;
        },

        /**
         * Show new result on the screen
         * @param {Object} newResult the new result or the result which is updated
         * @return {void}
         */
        showNewResult: function(newResult) {
            if ( ! newResult) return;
            newResult.imageBoxStyleString = 'width: 0; height: 0';
            newResult.imageStyleString = 'width: 0; height: 0';

            if (newResult.attachments && newResult.attachments.length > 0) {
                const img = newResult.attachments[0];
                const size = this.calcImageDisplaySize(img.metaWidth, img.metaHeight);
                newResult.imageBoxStyleString = ['width:', size.boxWidth, '; height:', size.boxHeight].join('');
                newResult.imageStyleString = ['width:', size.displayWidth, '; height:', size.displayHeight].join('');
            }


            // check if the result in results or not
            let index = this.activity.results.findIndex(ele => ele.user.id === newResult.user.id);

            // if not in the results, just push it to the end of the array
            if (index === -1) {
                this.activity.results.unshift(newResult);
                newResult.bgStyleString = 'background-color: ' + this.bgColors[this.activity.results.length % this.bgColors.length];
                let which = 'left';
                if (this.leftHeight <= this.rightHeight) {
                    this.leftResults.unshift(newResult);
                } else {
                    this.rightResults.unshift(newResult);
                    which = 'right';
                }

                // Get the rendered width and height
                Vue.nextTick(() => {
                    const box = document.querySelector('#result-box-' + newResult.id);
                    const rect = box.getBoundingClientRect();
                    newResult.height = rect.height;
                    which === 'left' ? this.leftHeight += (rect.height + 40) : this.rightHeight += (rect.height + 40);
                    console.log(this.$refs.positions.scrollTop);

                    if (this.$refs.positions.scrollTop > 400) return;
                    box.scrollIntoView();
                });
                return;
            }
            
            // if the result has in the array, remove it and readded to the end of the array
            const oldResult = this.activity.results.splice(index, 1)[0];
            // because the newResult message does not contains tags data, so we use the old result to test if the result should be shown
            if (oldResult.tags && oldResult.tags.length > 0) {
                newResult.tags = [];
                oldResult.tags.forEach(t => newResult.tags.push(t));
            }
            this.activity.results.unshift(newResult);
            
            newResult.bgStyleString = oldResult.bgStyleString;

            let isResultOnShown = true;
            if (this.selectedTagId != -1) {
                if (newResult && newResult.tags && newResult.tags.length > 0) {
                    isResultOnShown = newResult.tags.findIndex(t => t.id == this.selectedTagId) !== -1;
                } else {
                    isResultOnShown = false;
                }
            }

            // if the updated result is not shown on screen, we have finished our work
            if (! isResultOnShown) return;

            let which = 'left';

            index = this.leftResults.findIndex(ele => ele.user.id === newResult.user.id);
            if (index === -1) {
                index = this.rightResults.findIndex(ele => ele.user.id === newResult.user.id);
                if (index === -1) {
                    console.log('new result ', newResult.id, ' seems to be an updated result, but can not be found in left or right results collection');
                    return;
                }
                which = 'right';
            }

            console.log('find result ' + newResult.id + ' in ' + which);

            if (which === 'left') {
                this.leftHeight -= (oldResult.height + 40);
                this.leftResults.splice(index, 1);
            } else {
                this.rightHeight -= (oldResult.height + 40);
                this.rightResults.splice(index, 1);
            }

            if (this.leftHeight <= this.rightHeight) {
                this.leftResults.unshift(newResult);
                console.log('new result is pushed into left results');
            } else {
                this.rightResults.unshift(newResult);
                console.log('new result is pushed into right results');
            }

            // Get the rendered width and height
            Vue.nextTick(() => {
                const box = document.querySelector('#result-box-' + newResult.id);
                const rect = box.getBoundingClientRect();
                newResult.height = rect.height;
                which === 'left' ? this.leftHeight += (rect.height + 40) : this.rightHeight += (rect.height + 40);

                if (this.$refs.positions.scrollTop > 400) return;
                box.scrollIntoView();
            });
        },

        /**
         * Show the data on screen
         * clear the current data and recalculate results to show
         * @return {void}
         */
        showData: function() {
            // const testHeightResults = [];
            this.leftHeight = 0;
            this.leftResults.splice(0);
            this.rightHeight = 0;
            this.rightResults.splice(0);

            if (! this.shownResults || this.shownResults.length === 0) return;

            for (let i = 0, n = this.shownResults.length; i < n; i++) {
                const r = this.shownResults[i];
                r.bgStyleString = 'background-color: ' + this.bgColors[i % this.bgColors.length];
                if ( ! r.attachments || r.attachments.length == 0) {
                    r.imageBoxStyleString = 'width: 0px; height: 0px;';
                    r.imageStyleString = 'width: 0px; height: 0px;';
                    continue;
                }
                const imageObject = r.attachments[0];
                // console.log(imageObject);
                const size = this.calcImageDisplaySize(imageObject.metaWidth, imageObject.metaHeight);

                r.imageBoxStyleString = ['width:', size.boxWidth, '; height:', size.boxHeight].join('');
                r.imageStyleString = ['width:', size.displayWidth, '; height:', size.displayHeight].join('');
            }

            
            for (let i = 0, n = this.shownResults.length; i < n; i++) {
                this.tempResults.push(this.shownResults[i]);
            }

            this.$nextTick(() => {
                const tempBlocks = this.$refs.testHeightCol.querySelectorAll('.result-block');
                let leftHeight = 0;
                let rightHeight = 0;
                let leftIndexes = [];
                let rightIndexes = [];

                for (let i = 0, n = this.shownResults.length; i < n; i++) {
                    const r = this.shownResults[i];
                    const rect = tempBlocks[i].getBoundingClientRect();
                    r.height = rect.height;
                    if (leftHeight <= rightHeight) {
                        leftIndexes.push(i);
                        leftHeight += rect.height + 40;
                    } else {
                        rightIndexes.push(i);
                        rightHeight += rect.height + 40;
                    }
                }

                this.leftHeight = leftHeight;
                this.rightHeight = rightHeight;
                for (let i = 0, n = leftIndexes.length; i < n; i++) {
                    this.leftResults.push(this.shownResults[leftIndexes[i]]);
                }
                for (let i = 0, n = rightIndexes.length; i < n; i++) {
                    this.rightResults.push(this.shownResults[rightIndexes[i]]);
                }

                this.tempResults.splice(0);
            });
        },

        /**
         * Handle the show storm activity message
         * @param {Object} data the message data
         * @return {void}
         */
        handleShowMessage: function(data) {
            if (! data) return;
            this.resetScene();
            // make a deep copy
            data.activity.content = tool.htmlspecialchars(data.activity.content);
            data.activity.results.forEach(r => {
                r.content = tool.htmlspecialchars(r.content);
                r.submitTime = r.submitTime ? moment(r.submitTime).format('YYYY-MM-DD HH:mm:ss') : '';
            });

            // Sort the tags by tag ref count
            data.activity.tags.sort((a, b) => (a.resultCount - b.resultCount) * -1);
            this.memberCount = data.memberCount ? data.memberCount : 0;
            this.serverTimestamp = data.serverTimestamp;
            let results = [];
            data.activity.results.forEach(res => {
                results.unshift(res);
            });
            data.activity.results = results;
            this.activity = data.activity;
            this.shownResults = results;
            this.showData();
        },

        handleNewResultMessage: function(msgData) {
            if (! msgData) return;
            console.log(msgData);
            let data = JSON.parse(JSON.stringify(msgData));
            if (data.memberCount) this.memberCount = data.memberCount;
            const result = data.newResult;
            result.content = tool.htmlspecialchars(result.content);
            result.submitTime = moment(result.submitTime).format('YYYY-MM-DD HH:mm:ss');
            
            this.showNewResult(result);
        },

        /**
         * handle like like message
         * @param {Object} msgData the like message
         * @return {void}
         */
        handleLikeMessage: function(msgData) {
            if ( ! msgData || ! msgData.likeData) return;
            
            const index = this.activity.results.findIndex(ele => ele.user.id === msgData.likeData.resultUserId);

            if (index === -1) {
                console.error('storm activity like message received, but not found the result', msgData.likeData);
                return;
            }

            const result = this.activity.results[index];
            let {likeCount, score, scoreCount, whoLike} = msgData.likeData;
            result.likeCount = likeCount;
            result.likeScore = scoreCount;

            // if the storm is not the front layer scene, do not play the animation
            if (this.currentShow !== this.componentId || this.isLock) return;

            const avatar = document.querySelector('#result-box-' + result.id).querySelector('.result-header > .avatar > img');
            this.wingsAll.pushAnimation(avatar, result.user.fullName, '+' + score);
        },

        handleCancelLikeMessage: function(msgData) {
            if ( ! msgData || ! msgData.likeData) return;
            const index = this.activity.results.findIndex(ele => ele.user.id === msgData.likeData.resultUserId);

            if (index === -1) {
                console.error('storm activity cancel like message received, but not found the result', msgData.likeData);
                return;
            }

            const result = this.activity.results[index];
            const {likeCount = 0, scoreCount = 0, whoLike} = msgData.likeData; 

            result.likeCount = likeCount;
            result.likeScore = scoreCount;
        },

        /**
         * Show result image
         * @param {string} resultId the target result id
         * @return {void}
         */
        handleShowImageMessage: function(resultId) {
            if ( ! resultId) return;
            const index = this.activity.results.findIndex(e => e.id === resultId);
            if (index === -1) {
                console.log('show result message received, but can not find the result with id ', resultId);
                return;
            }

            const result = this.activity.results[index];
            if (! result.attachments || result.attachments.length === 0) {
                console.log('it seems the result', resultId, ' has no image atachment');
                return;
            }

            const img = result.attachments[0];
            this.showImage({
                relationId: img.relationId,
                src: img.url,
                baseFactor: 1.0,
                styleString: ''
            });
        },

        /**
         */
        handleHideImageMessage: function() {
            this.selectedImage = null;
            this.selectedImageScale = null;
            this.$refs.selectedImage.style.transform = '';
            this.moveX = 0;
            this.moveY = 0;
            this.rotate = 0;
        },

        handleSelectTagMessage: function(msgData) {
            if (msgData.tagId == -1) {
            } else {
                const tagIndex = this.activity.tags.findIndex(e => e.id == msgData.tagId);
                if (tagIndex === -1) {
                    console.log('received select tag message, but cat not find tag with id ', msgData.tagId);
                    return;
                }
            }
            this.selectedTagId = msgData.tagId;
            
            if (this.selectedTagId == -1) {
                this.shownResults = this.activity.results;
            } else {
                this.shownResults = this.activity.results.filter(r => r.tags && r.tags.length > 0 && r.tags.findIndex(t => t.id == msgData.tagId) !== -1);
            }
            this.showData();
        },

        /**
         * New tag added
         * @param {Object} msgData the message data
         * @return {void}
         */
        handleAddTagMessage: function(msgData) {
            if (! msgData) return;
            // add to the result
            let index = this.activity.results.findIndex(r => r.id === msgData.resultId);
            
            if (index >= 0) {
                const result = this.activity.results[index];
                if (result.tags.findIndex(t => t.id == msgData.tagId) === -1) {
                    result.tags.push({
                        id: msgData.tagId,
                        tag: msgData.tag
                    });
                }
            }
            

            // update the total
            index = this.activity.tags.findIndex(t => t.id == msgData.tagId);
            if (index === -1) {
                this.activity.tags.push({
                    id: msgData.tagId,
                    tag: msgData.tag,
                    resultCount: 1
                });
            } else {
                this.activity.tags[index].resultCount += 1;
            }
        },

        /**
         * Handle tag removed message
         * @param {Object} msgData the message data
         * @return {void}
         */
        handleRemoveTagMessage: function(msgData) {
            // adjust the result
            let index = this.activity.results.findIndex(r => r.id === msgData.resultId);
            if (index >= 0) {
                const result = this.activity.results[index];
                index = result.tags.findIndex(t => t.id == msgData.tagId);
                if (index >= 0) {
                    result.tags.splice(index, 1);
                }
            }

            // the total
            index = this.activity.tags.findIndex(t => t.id == msgData.tagId);
            if (index === -1) return;
            const t = this.activity.tags[index];
            if (t.resultCount > 1) {
                t.resultCount -= 1;
            } else {
                this.activity.tags.splice(index, 1);
            }
        },

        /**
         * Handle intelligent tag message
         * @return {void}
         */
        handleIntelliTagMessage: function() {

        },

        /**
         * Expand a result
         * @param {string} resultId the result id to expand
         * @return {void}
         */
        expandResult: function(resultId) {
            console.log('going to expand result', resultId);
            if (! resultId) return;
            let index = this.activity.results.findIndex(r => r.id === resultId);
            if (index === -1) {
                console.log('show result message received: ', resultId, ', but no result find in the results collection');
                return;
            }

            this.selectedResult = this.activity.results[index];
            this.$refs.positions.style.overflowY = 'hidden';
            // console.log(this.$refs.positions.style)
        },

        /**
         * Collapse a result
         * @return {void}
         */
        collapseResult: function() {
            this.selectedResult = null;
            this.$refs.positions.style.overflowY = 'auto';
        },

        /**
         * Show an image
         * @param {Object} imgObject should have src property
         */
        showImage: function(imgObject) {
            if (! imgObject || ! imgObject.src) return;
            let loadingWidth = 100;
            let loadingHeight = 100;

            this.selectedImage = {
                relationId: imgObject.relationId,
                src: loading,
                styleString: 'left: ' + Math.round(window.innerWidth - loadingWidth) / 2 + 'px; top: ' + Math.round(window.innerHeight - loadingHeight) / 2 + 'px; transform: scale(1.0);',
                baseFactor: 1.0
            };

            let tempImage = new Image();
            tempImage.addEventListener('load', () => {
                let factor = 1.0;

                if (tempImage.width < window.innerWidth && tempImage.height < window.innerHeight) {

                } else {
                    factor = Math.max(tempImage.width / window.innerWidth, tempImage.height / window.innerHeight);
                }
                factor = 1 / factor;

                this.selectedImage = {
                    relationId: imgObject.relationId,
                    src: tempImage.src,
                    styleString: 'left: ' + Math.round(window.innerWidth - tempImage.width) / 2 + 'px; top: ' + Math.round(window.innerHeight - tempImage.height) / 2 + 'px; transform: scale(' + factor + ');',
                    baseFactor: factor
                };

                this.selectedImageScale = factor;
            });
            tempImage.src = imgObject.src;

        },

        /**
         * calculate the result image display size
         * @param {number} imageWidth the image width
         * @param {number} imageHeight the image height
         * @return {Object} with 4 properties are set: boxWidth, boxHeight, displayWidth, displayHeight. 
         *          each property is a string in 'npx' format or 'auto'
         */
        calcImageDisplaySize: function(imageWidth, imageHeight) {
            if (! imageWidth || ! imageHeight || imageWidth <= 0 || imageHeight <= 0) {
                console.log('can not calculate the image disaplay size');
                return {
                    boxWidth: '0',
                    boxHeight: '0',
                    displayWidth: '0',
                    displayHeight: '0'
                };
            }

            const maxWidth = 500;
            const maxHeight = 200;

            if (imageWidth <= maxWidth && imageHeight <= maxHeight) {
                return {
                    boxWidth: imageWidth + 'px',
                    boxHeight: imageHeight + 'px',
                    displayWidth: imageWidth + 'px',
                    displayHeight: imageHeight + 'px'
                };
            } 

            if (imageHeight / imageWidth >= 2) {
                return {
                    boxWidth: '100px',
                    boxHeight: '200px',
                    displayWidth: '100px',
                    displayHeight: 'auto'
                };
            }

            if (imageWidth / imageHeight >= 5) {
                return {
                    boxWidth: '500px',
                    boxHeight: '100px',
                    displayWidth: 'auto',
                    displayHeight: '100px'
                };
            }

            let xFactor = imageWidth / maxWidth;
            let yFactor = imageHeight / maxHeight;
            if (xFactor > yFactor) {
                return {
                    boxWidth: '500px',
                    boxHeight: (imageHeight / xFactor).toFixed(0) + 'px',
                    displayWidth: '500px',
                    displayHeight: 'auto'
                };
            } else {
                return {
                    boxWidth: (imageWidth / yFactor).toFixed(0) + 'px',
                    boxHeight: '200px',
                    displayWidth: 'auto',
                    displayHeight: '200px'
                };
            }
        },

        handleResetImage: function() {
            let img = document.createElement('img');
            img.src = detailIcon;
            let subjectBox = this.$refs.subjectBox.querySelector('.text-content');
            if (!this.activity.image) return;
            subjectBox.appendChild(img);
        },

        rotateImg: function(msgData) {
            this.rotate += 90;
            let quizImg = this.$refs.selectedImage;
            quizImg.style.transform = tool.getImgStyle(this.selectedImageScale, this.moveX, this.moveY, this.rotate);
        },

        // zoom to resultImage
        zoomTo: function(msgData) {
            this.moveX = 0;
            this.moveY = 0;
            if (msgData.id != this.selectedImage.relationId) return;
            let newFactor = msgData.scaleFactor.toFixed(4);
            this.selectedImageScale = newFactor;
            this.$refs.selectedImage.style.transform = tool.getImgStyle(this.selectedImageScale, this.moveX, this.moveY, this.rotate);
        },

        moveJoystick: function(msgData) {
            
            console.log(msgData);
            let box = null;
            let positions = this.$refs.positions;
            let expandResultBox = this.$refs.expandResultBox;
            let direction = msgData.direction;
            if (this.selectedImage != null) {
                this.moveForSelectedImage(direction);
            } else if (this.selectedResult != null) {
                box = expandResultBox;
                this.justUpAndDown(direction,box);
            } else if (this.selectedImage != null) {
                this.moveForSelectedImage(direction);
            } else {
                box = positions;
                this.justUpAndDown(direction,box);
            }

        },

        justUpAndDown: function(direction,box) {
            
            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                box.scrollTop -= 40;
                // box.scrollIntoView();
            } else if (direction === 'DOWN') {
                box.scrollTop += 40;
                // box.scrollIntoView();
            } else {
                return;
            }
        },

        moveForSelectedImage: function(direction) {
            if (direction === 'LEFT') {
                this.moveX += 40;
            } else if (direction === 'RIGHT') {
                this.moveX -= 40;
            } else if (direction === 'UP') {
                this.moveY += 40;
            } else if (direction === 'DOWN') {
                this.moveY -= 40;
            } else {
                return;
            }

            this.$refs.selectedImage.style.transform = tool.getImgStyle(this.selectedImageScale, this.moveX, this.moveY, this.rotate);
        },
    }
};
</script>

<style scoped>
    .storm-box {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .title-bar {
        display: flex;
        align-items: flex-start;
        height: 40px;
        padding: 20px 40px 20px 40px;
        background-color: #191919;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9;
    }

    .title-bar .led-timer {
        flex-grow: 0;
        width: 320px;
    }

    .title-bar .stat-info {
        flex-grow: 0;
        width: 350px; 
        line-height: 36px;
        vertical-align: middle;
    }

    .title-bar .stat-info .label {
        flex-grow: 1;
        font-size: 18px;
        color: #BBC2C6;
        vertical-align: middle;
        padding: 0 10px;
    }

    .title-bar .stat-info .data {
        display: inline-block;
        font-size: 30px;
        color: #ffffff;
        vertical-align: middle;
    }

    .title-bar .title {
        height: 40px;
        line-height: 40px;
        vertical-align: middle;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        font-size: 24px;
        flex-grow: 1;
        color: #ffffff;
    }

    .title-bar .title.no-timer {
        margin-left: 320px;
    }

    .positions{
        width: 100%;
        position: fixed;
        top: 80px;
        left: 0;
        bottom: 0;
        right: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .subject-box {
        background-color: #191919;
        padding: 10px 40px;
        text-align: left;
        overflow-x: hidden;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .subject-box .text-content {
        font-size: 1.5rem;
        color: #BBC2C6;
    }

    .text-content > span {
        vertical-align: middle;
    }

    .text-content > img {
        width: 1.5rem;
        height: 1.5rem;
        margin-left: 10px;
        vertical-align: middle;
        margin-top: -0.2rem;
    }

    .tag-box {
        background-color: #252525;
        padding: 0px 40px 20px 40px;
    }

    .tag-box .tag {
        margin-top: 20px;
        height: 2.5rem;
        line-height: 2.5rem;
        vertical-align: middle;
        border: 2px solid #bbc2c6;
        border-radius: 1.375rem;
        padding: 0 35px;
        text-align: center;
        font-size: 1.5rem;
        color: #bbc2c6;
        float: left;
        margin-left: 20px; 
    }

    .tag-box .tag:first-child {
        margin-left: 0;
    }

    .tag-box .tag.selected {
        background-color: #4A7FB5;
        border-color: #4A7FB5;
        color: #ffffff;
    }

    .result-box {
        box-sizing: border-box;
        padding: 0px 40px;
        overflow-y: auto; 
        display: flex;
        flex-direction: row;
        align-items: flex-start;
    }

    .result-box .left-col {
        box-sizing: border-box;
        min-height: 20px;
        width: 50%;
        padding-right: 20px;
    }

    .result-box .right-col {
        box-sizing: border-box;
        min-height: 20px;
        width: 50%;
        padding-left: 20px;
    }

    .result-box .result-block {
        border-radius: 8px;
        background-color: #D18400;
        color: #ffffff;
        padding: 30px;
        margin-bottom: 40px;
    }

    .result-block .result-header {
        height: 80px;
        display: flex;
    }

    .result-block .result-header .avatar {
        width: 72px;
        height: 72px;
        border: 4px solid #ffffff;
        border-radius: 40px;
        flex-grow: 0;
        flex-shrink: 0;
        overflow: hidden;
    }

    .result-block .result-header .avatar img {
        width: 100%;
        height: 100%;
    }

    .result-block .result-header .info {
        flex-grow: 1;
        padding-left: 20px;
    }

    .result-block .result-header .info .name,
    .result-block .result-header .info .student-no {
        font-size: 24px;
        color: inherit;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: left;
     }

    .result-block .result-header .info .name {
        padding-top: 6px;
        padding-bottom: 4px;
     }

    .result-block .result-body {
        padding-top: 40px;
        
    }

    .result-block .result-body .text-content {
        text-align: left;
        font-size: 1.5rem;
        line-height: 150%;
        word-wrap: break-word;
        overflow: hidden;
    }

    .result-block .result-body .image-box {
        padding-top: 20px;
        max-width: 500px;
        max-height: 200px;
        overflow: hidden;
        text-align: left;
    }

    .result-block .result-body .image-box img {

    }

    .result-block .result-footer {
        padding-top: 40px;
    }

    .result-block .result-footer .time-info {
        padding-bottom: 10px;
        text-align: left;
        font-size: 18px;
        color: #ffffff;
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    }

    .result-block .result-footer .like-info {
        padding-top: 24px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 24px;
        color: #ffffff;
        text-align: left;
    }

    /* When there are Chinese characters and English charaters, the virtical align becomes wired. Force vertical align to middle */
    .result-block .result-footer .like-info .like-score {
        padding-right: 10px;
        height: 36px;
        line-height: 36px;
        vertical-align: middle;
    }

    .result-block .result-footer .like-info .like-button {
        height: 36px;
        width: 36px;
        background-image: url('../assets/image/like-count-0.png');
        background-size: 30px 30px;
        background-position: 0 3px;
        background-repeat: no-repeat;
    }

    .result-block .result-footer .like-info .like-button.has-like {
        background-image: url('../assets/image/like-count.png');
    }


    .result-block .result-footer .like-info .like-count {
        height: 36px;
        line-height: 36px;
        vertical-align: middle;
        padding-left: 10px;
    }

    .empty-result-hint {
        position: absolute;
        left: 0px;
        top: 80px;
        right: 0px;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .empty-result-hint .hint-content {
        width: 300px;
        padding-top: 230px;
        background-image: url('../assets/image/brainstorm_icon.png');
        background-size: 200px 200px;
        background-position: 50% 0;
        background-repeat: no-repeat;
        font-size: 24px;
        color: #ffffff;
    }

    .expand-result-container {
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #252525;
        padding-top: 40px;
        padding-bottom: 40px;
        padding-left: 70px;
        padding-right: 70px;
        display: flex;
        flex-direction: column;
    }

    .expand-result-container.has-tags {
        padding-top: 0;
        /* top: 0; */
    }
    
    .expand-result-container .tag-box {
        padding-left: 0;
        flex-shrink: 0;
        flex-grow: 0;
    }

    .expand-result-container .expand-result-box {
        overflow-x: hidden;
        overflow-y: auto;
        flex-grow: 1;
    }
    
    .expand-result-box .result-block .result-header {
        display: flex;
    }
    
    .expand-result-box .result-block .result-header .left {
        display: flex;
        flex-grow: 1;
    }

    .expand-result-box .result-block .result-header .right {
        width: 280px;
        flex-grow: 0;
        
    }

    .expand-result-box .result-block .result-header .time-info {
        padding-top:18px;
        text-align: right;
        font-size: 18px;
        color: #BBC2C6;
    }

    .expand-result-box .result-block .result-header .like-info {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .expand-result-box .result-block .result-header .like-info .like-score {
        font-size: 24px;
        color: #8FC31F;
    }

    .expand-result-box .result-block .result-header .like-info .like-button {
        height: 36px;
        width: 36px;
        background-image: url('../assets/image/like-count-0.png');
        background-size: 30px 30px;
        background-position: 0 3px;
        background-repeat: no-repeat;
        margin-left: 10px;
    }

    .expand-result-box .result-block .result-header .like-info .like-button.has-like {
        background-image: url('../assets/image/like-count.png');
    }

    .expand-result-box .result-block .result-header .like-info .like-count {
        margin-left: 10px;
        font-size: 24px;
    }

    .expand-result-box .result-block .result-body {
        padding-left: 100px;
    }

    .expand-image-box {
        position: fixed;
        overflow: hidden;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 9;
    }

    .expand-image-box img {
        position: absolute;
        transition: transform 300ms linear;
    }

    .imgAnimation {
        animation: load 1s;
        animation-timing-function: linear;
        animation-direction: reverse;
        animation-iteration-count: infinite;
    }

    @keyframes load {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(-360deg);
        }
    }
</style>


